import * as microsoftTeams from '@microsoft/teams-js';
import {
  FluentProvider,
  Spinner,
  teamsDarkTheme,
} from '@fluentui/react-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MeetingStage from './pages/MeetingStage';
import SidePanel from './pages/SidePanel';
import TabConfig from './pages/TabConfig';
import { inTeams } from './utils/inTeams';
import axios from 'axios';
import React, { useMemo } from 'react';

export const MediaContext = React.createContext();

export const MediaLinkContext = React.createContext({
  link: '',
  setLink: () => {},
});

export const AuthContext = React.createContext({
  isAuthenticated: false,
  setIsAuthenticated: () => {},
});

const isLoggedIn = !!window.localStorage.getItem('email');

export default function App() {
  const [initialized, setInitialized] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [mediaFetched, setMediaFetched] = useState(false);
  const [linkFetched, setLinkFetched] = useState(false);
  const [link, setLink] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(isLoggedIn);

  const value = useMemo(() => ({ link, setLink }), [link]);
  const authValue = useMemo(
    () => ({ isAuthenticated, setIsAuthenticated }),
    [isAuthenticated]
  );

  const fetchMediaList = async () => {
    const config = {
      headers: {
        'x-api-key': 'wx2DuCyalZ8dsWS8Yebzi3BMYBuKfrqh9oxp3aqE',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    };
    const url = "https://teams-app.getapeptalk.com/links";

    const response = await axios.get(url, config);
    setMediaList(response.data);
    setMediaFetched(true);
    fetchFirstLink(response);
  };

  const fetchFirstLink = async (e) => {
    const id = e.data[0].content[0].id;

    const config = {
      headers: {
        'x-api-key': 'wx2DuCyalZ8dsWS8Yebzi3BMYBuKfrqh9oxp3aqE',
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    };
    const url = "https://teams-app.getapeptalk.com/linkssession/" + id;
    const response = await axios.get(url, config);
    setLink(response.data.download);
    setLinkFetched(true);
  };

  useEffect(() => {
    fetchMediaList();
  }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        console.log('App.js: initializing client SDK initialized');
        await microsoftTeams.app.initialize();
        microsoftTeams.app.notifyAppLoaded();
        microsoftTeams.app.notifySuccess();
        setInitialized(true);
      } catch (error) {
        console.error(error);
      }
    };

    if (inTeams()) {
      console.log('App.js: initializing client SDK');
      initialize();
    }
  });

  const appReady =
    (inTeams() && initialized && mediaFetched && linkFetched) ||
    (!inTeams() && mediaFetched && linkFetched);

  if (!appReady)
    return (
      <FluentProvider
        theme={teamsDarkTheme}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'transparent',
          height: '100vh',
          width: '100vw',
        }}
      >
        <Spinner />
      </FluentProvider>
    );

  return (
    <FluentProvider
      theme={teamsDarkTheme}
      style={{
        minHeight: '0px',
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        overflow: 'hidden',
        backgroundColor: inTeams() ? 'transparent' : '#202020',
      }}
    >
      <AuthContext.Provider value={authValue}>
        <MediaContext.Provider value={mediaList}>
          <MediaLinkContext.Provider value={value}>
            <Router window={window} basename="/">
              <Routes>
                <Route exact path={'/'} element={<MeetingStage />} />
                <Route exact path={'/sidepanel'} element={<SidePanel />} />
                <Route exact path={'/config'} element={<TabConfig />} />
              </Routes>
            </Router>
          </MediaLinkContext.Provider>
        </MediaContext.Provider>
      </AuthContext.Provider>
    </FluentProvider>
  );
}
